import { Avatar, Box, Button, Container, FormControl, styled, TextField, Typography } from "@mui/material";
import LockIcon from '@mui/icons-material/Lock';
import { userLogin } from "../../utils/httpClient";
import { useState } from "react";
import { CustomAlretDialog } from "../Components/Dialog";
import { useNavigate } from "react-router-dom";

const Login = (props) => {
  // "/v2/auth/login/admin", {

  const navigate = useNavigate();
  // 다이어로그 메세지
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState('');

  const showDialog = (message) => {
    setDialogMessage(message);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget); // formData 객체 가져오는 형식
    const id = formData.get('id');
    const password = formData.get('password');

    if (!id || !password) {
      showDialog('아이디와 패스워드를 입력해주세요.');
      return;
    }
    await userLogin(id, password).then((res) => {
      if (res.statusCode === 200) {
        if (res.data.role !== 'head') {
          showDialog('본사만 로그인이 가능합니다');
          return
        }
        sessionStorage.setItem("gonggam-accessToken", res.data.AccessToken);
        navigate('/admin/inquiry');
      }
      else {
        showDialog(`${res?.errorMessage}`);
      }
    }).catch((err) => {
      console.error("Error:", err);
      showDialog('아이디 또는 패스워드가 잘못되었습니다.');
    });

  };

  const StyledTextField = styled(TextField)({
    '& label': {
      backgroundColor: '#fff',
      padding: '0 4px',
    },
    '& label.Mui-focused': {
      backgroundColor: '#fff',  // 포커스 시 라벨 배경색을 흰색으로 설정 (포커스되었을때 텍스트하고 input 하고 겹치는 버그발생)
      padding: '0 4px',
    },
  });



  return (
    <Container maxWidth="sm" style={{ height: '100vh', position: "relative" }}>
      <div
        style={{
          width: '400px',
          position: "absolute",
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >

        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '16px'
        }}>
          <Avatar>
            <LockIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            로그인
          </Typography>
        </div>
        <Box
          component="form"
          onSubmit={handleSubmit}
          noValidate
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            gap: 2,
          }}
        >
          <FormControl>
            <StyledTextField
              type="text"
              name="id"
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="아이디"
              autoFocus
              autoComplete="off"
            />
          </FormControl>
          <FormControl>
            <StyledTextField
              type="password"
              name="password"
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="비밀번호"
              autoComplete="off"
            />
          </FormControl>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
          >
            로그인
          </Button>
        </Box>
      </div>

      <CustomAlretDialog
        open={dialogOpen}
        message={dialogMessage}
        close={handleDialogClose}
      />

    </Container>

  );
}

export default Login;
